const checkAndPrepareRating = (rating: number | string | null) => {
	if (rating === null) {
		return "0";
	}
	return typeof rating === "number" ? rating.toFixed(1) : rating;
};

export default checkAndPrepareRating;
